import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <nav className="navbar">
        <ul className="nav-list">
          <li>
            <Link to="/">Accueil</Link>
          </li>
          <li>
            <Link to="/projets">Projets</Link>
          </li>
          <li>
            <Link to="/entreprise">Entreprise</Link>
          </li>
          <li>
            <Link to="/journee-type">Journée Type</Link>
          </li>
          <li>
            <Link to="/veille-techno">Veille Techno</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>

        </ul>
      </nav>
    </header>
  );
}

export default Header;
